export const YEAR_SECONDS = 365 * 24 * 60 * 60;

export interface CookieOptions {
  maxAge?: number;
  path?: string;
  sameSite?: "strict" | "lax" | "none";
  secure?: boolean;
  httpOnly?: boolean;
}

export interface CookieDefinition {
  name: string;
  options: CookieOptions;
  hasSecureVariant?: boolean;
}

const defaults = { path: "/", sameSite: "lax" } as const;

export const Cookies = {
  viewerFingerprint: {
    name: "g_v",
    options: { ...defaults, maxAge: YEAR_SECONDS, httpOnly: true },
  },
  locale: { name: "g_l", options: { ...defaults, maxAge: YEAR_SECONDS } },
  currency: { name: "g_c", options: { ...defaults, maxAge: YEAR_SECONDS } },
  timezone: { name: "g_t", options: { ...defaults, maxAge: YEAR_SECONDS } },
  advertisingConsent: { name: "g_ac", options: { ...defaults, maxAge: YEAR_SECONDS } },
  redirectAfterLogin: { name: "g_r", options: { ...defaults, maxAge: 5 * 60 } },
  addToListsIntent: { name: "g_i", options: { ...defaults, maxAge: 30 * 60 } },
  sessionToken: {
    hasSecureVariant: true,
    name: "g_s",
    options: { ...defaults, maxAge: 7 * 24 * 60 * 60, httpOnly: true },
  },
  dontRemember: { hasSecureVariant: true, name: "g_nr", options: { ...defaults, httpOnly: true } },
  authState: {
    hasSecureVariant: true,
    name: "g_st",
    options: { ...defaults, maxAge: 5 * 60, httpOnly: true },
  },
} as const satisfies Record<string, CookieDefinition>;

export const LegacyCookies = {
  visitorId: { name: "garimpa_visitor_id", options: defaults },
  marketingAttribution: {
    name: "garimpa_marketing_attribution_v1",
    options: defaults,
  },
  locale: { name: "locale", options: defaults },
  currency: { name: "currency", options: defaults },
  timezone: { name: "timezone", options: defaults },
  redirectAfterLogin: { name: "redirect-after-login", options: defaults },
  addToListsIntent: {
    name: "add-to-lists-intent",
    options: defaults,
  },
  authSession: { hasSecureVariant: true, name: "better-auth.session_token", options: defaults },
  authDontRemember: {
    hasSecureVariant: true,
    name: "better-auth.dont_remember",
    options: defaults,
  },
  authState: { hasSecureVariant: true, name: "better-auth.state", options: defaults },
} as const satisfies Record<string, CookieDefinition>;
